import axios from 'axios'
import u from '@/utils'

const state = {
  inboundPackages: [],
  outboundPackages: [],
  inboundPackageCount: 0,
  outboundPackageCount: 0,
  packageDeploymentCount: 0,
  packageDeployments: []
}

const mutations = {
  setInboundPackages(state, inboundPackages) {
    state.inboundPackages = inboundPackages
  },
  setOutboundPackages(state, outboundPackages) {
    state.outboundPackages = outboundPackages
  },
  setInboundPackageCount(state, inboundPackageCount) {
    state.inboundPackageCount = inboundPackageCount
  },
  setOutboundPackageCount(state, outboundPackageCount) {
    state.outboundPackageCount = outboundPackageCount
  },
  setPackageDeployments(state, packageDeployments) {
    state.packageDeployments = packageDeployments
  },
  setPackageDeploymentCount(state, packageDeploymentCount) {
    state.packageDeploymentCount = packageDeploymentCount
  }
}

const actions = {
  async fetchInboundPackages({ commit }, urlParams) {
    let url = '/api/v1/packages?packageType=INBOUND'
    if (urlParams !== undefined && urlParams !== null) {
      url = url + '&' + urlParams
    }
    let response = await axios.get(url)
    let packages = [...response.data._embedded.packages]
    packages = packages.map(i => u.processResp(i))
    commit('setInboundPackages', packages)
    return packages
  },

  async fetchOutboundPackages({ commit }, urlParams) {
    let url = '/api/v1/packages?packageType=OUTBOUND'
    if (urlParams !== undefined && urlParams !== null) {
      url = url + '&' + urlParams
    }
    let response = await axios.get(url)
    let packages = [...response.data._embedded.packages]
    packages = packages.map(i => u.processResp(i))
    commit('setOutboundPackages', packages)
    return packages
  },

  async fetchInboundPackagesCount({ commit }) {
    let url = '/api/v1/packages/count?packageType=INBOUND'
    let response = await axios.get(url)
    let count = response.data
    commit('setInboundPackageCount', count)
    return count
  },

  async fetchOutboundPackagesCount({ commit }) {
    let url = '/api/v1/packages/count?packageType=OUTBOUND'
    let response = await axios.get(url)
    let count = response.data
    commit('setOutboundPackageCount', count)
    return count
  },

  async createPackage(context, body) {
    let url = '/api/v1/packages'
    let response = await axios.post(url, body)
    return response.data
  },

  async setSourceVersion(context, body) {
    let url = '/api/v1/packages/set-version'
    let response = await axios.post(url, body)
    return response.data
  },

  async updateSourceVersion(context, body) {
    let url = '/api/v1/packages/update-version'
    let response = await axios.post(url, body)
    return response.data
  },

  async pushToRemoteTulip(context, data) {
    let url = `/api/v1/packages/${data.id}/push`
    let response = await axios.post(url, data.body)
    return response.data
  },

  async deploySelectedPackage(context, data) {
    let url = `/api/v1/packages/${data.id}/deploy`
    let response = await axios.post(url, data.body)
    return response.data
  },

  async checkSelectedPackage(context, hexId) {
    let url = `/api/v1/packages/${hexId}/check`
    let response = await axios.post(url)
    return response.data
  },

  async importPackage(context, formData) {
    let response = await axios.post(`/api/v1/packages/import`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    return response.data
  },

  async importPackageFromFile(context, hexId) {
    let response = await axios.post(
      `/api/v1/packages/import-from-path/${hexId}`
    )
    return response.data
  },

  async fetchPackageDeployments({ commit }, data) {
    let url = `/api/v1/packageDeployments?packageId=${data.id}`
    if (data.urlParams !== undefined && data.urlParams !== null) {
      url = url + '&' + data.urlParams
    }
    let response = await axios.get(url)
    let packages = [...response.data._embedded.packageDeployments]
    packages = packages.map(i => u.processResp(i))
    commit('setPackageDeployments', packages)
    return packages
  },

  async fetchPackageDeploymentCount({ commit }, id) {
    let url = `/api/v1/packageDeployments/count?packageId=${id}`
    let response = await axios.get(url)
    let count = response.data
    commit('setPackageDeploymentCount', count)
    return count
  }
}

export default {
  state,
  actions,
  mutations
}
